require('./mortgageRequestExpensesMortgage.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const Immutable = require('immutable');
const { FormattedText } = require('core/i18n').i18n;
// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestExpensesItemList = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesItemList');
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @ constants
const { currencyExpensesParams } = require('constants/mortgageRequestCurrencyFormats');

class MortgageRequestExpensesMortgage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
            id: 'mortgage'
        };
    }

    render() {
        const { mortgageAmmount, totalGastosHipoteca } = this.props;

        const expensesItemClasses = {
            item: ['mortgage-request-expenses-mortgage__item', 'row'],
            title: ['col-xs-9'],
            value: ['mortgage-request-expenses-mortgage__value', 'col-xs-3'],
            list: ['mortgage-request-expenses-mortgage', 'list-unstyled'],
        };
        const itemList = [
            {
                text: 'mortgageRequestCommons-notary',
                value: mortgageAmmount.get('notaria')
            },
            {
                text: 'mortgageRequestExpensesMortgage-ajd',
                value: mortgageAmmount.get('ajd')
            },
            {
                text: 'mortgageRequestCommons-register',
                value: mortgageAmmount.get('registro')
            },
            {
                text: 'mortgageRequestCommons-management',
                value: mortgageAmmount.get('gestoria')
            },
            {
                text: 'mortgageRequestExpensesMortgage-comission',
                value: mortgageAmmount.get('comisionApertura')
            },
        ];

        const mortgageTotal = MortgageRequestCurrencyHelp(currencyExpensesParams(totalGastosHipoteca));
        const rightContentTotal = (
            <div className="mortgage-request-expenses-mortgage__amount">
                {mortgageTotal}
            </div>
        );

        return (
            <Accordion
                customClassName="mortgage-request-expenses-mortgage"
                isExpanded={this.state.isExpanded}
                id={this.state.id}
            >
                <AccordionHeader name="AccordionHeader" iconStyle isMiddleArrowPosition rightContent={rightContentTotal}>
                    <div className="mortgage-request-expenses-mortgage__header row no-outside-gutter">
                        <FormattedText value="mortgageRequestCommons-mortgageExpensesText"/>
                    </div>
                </AccordionHeader>

                <AccordionBody name="AccordionBody">
                    <MortgageRequestExpensesItemList
                        expensesItemClasses={expensesItemClasses}
                        itemsList={itemList}
                    />
                </AccordionBody>
            </Accordion>
        );
    }
}

MortgageRequestExpensesMortgage.propTypes = {
    mortgageAmmount: PropTypes.object.isRequired,
    totalGastosHipoteca: PropTypes.number.isRequired
};

MortgageRequestExpensesMortgage.defaultProps = {
    mortgageAmmount: Immutable.Map(),
    totalGastosHipoteca: 0
};

module.exports = MortgageRequestExpensesMortgage;
